import { useEffect } from 'react';
import { useNotify } from 'react-admin';
import { useLocation } from 'react-router';
import { usePermissionsOptimized } from '../../components/identity';
import { canAccess } from '../../ra-rbac';
import { QuickbooksCard } from './QuickbooksCard';
import { VaultConnections } from './VaultConnections';
import ConnectorList from '../connectors/ConnectorList';

export const IntegrationSettings = (props: any) => {
    const notify = useNotify()
    const { search } = useLocation()
    useEffect(() => {
        const params = new URLSearchParams(search);
        if (params.get('error')) {
            notify(params.get('error'), "error")
        }
    }, [notify, search])

    const { permissions } = usePermissionsOptimized();
    return (
        <>
            <ConnectorList/>
            <br/>
            {canAccess({ permissions, resource: 'allow-quickbooks', action: '*', }) && <QuickbooksCard />}
            {<VaultConnections />}
        </>
    );
};
